export default __webpack_public_path__ + "static/media/axgen-shot.7b5d759c.png";